import { compose, withProps, branch, renderComponent } from "recompose";
import { path } from "ramda";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { parse } from "query-string";
import yup from "yup";
import { createErrorsSelector } from "core/helpers";
import { fetchApi } from "core/api/hoc";
import { withActions } from "core/redux/hoc";
import { withHOC } from "core/react/hoc";
import * as feedbackModel from "modules/feedback/model";
import { Message } from "components/generic/pages";
import View from "./View";

export default withHOC(props =>
  compose(
    withRouter,
    fetchApi(props.fetchFeedbackApi, ({ location }) => {
      const { booking_id, target_id } = parse(location.search);

      return {
        key: "info",
        selector: props.fetchFeedbackApiSelector,
        sync: true,
        payload: {
          targetId: target_id,
          bookingId: booking_id
        }
      };
    }),
    branch(
      path(["info", "error"]),
      renderComponent(
        compose(
          withProps(({ info }) => ({
            title: "Error!",
            text: info.error.message
          }))
        )(Message)
      )
    ),
    connect(
      createStructuredSelector({
        submitApi: props.submitApiSelector,
        errors: createErrorsSelector(props.submitApiSelector)
      })
    ),
    withActions({
      onSubmit: ({ info }) => data =>
        props.submitApi.request({
          reviewId: info.data.id,
          data: feedbackModel.formDataToResponse(data)
        })
    }),
    withProps(({ info }) => ({
      initialValues: props.initialValues,
      validationSchema: yup.object().shape({
        general: yup.string().required("This field is required"),
        ...feedbackModel.getQuestionsIds(info.data.responses).reduce(
          (acc, id) => ({
            ...acc,
            [id]: yup.string().required()
          }),
          {}
        )
      })
    }))
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/common/feedback/LeaveFeedback/Provider.js